import { GlobalStatesV3 } from '../../commonv3/states/GlobalStatesV3';
import { createContext } from 'react';

export const GlobalContext = createContext(GlobalStatesV3);
